export const RED = '#ED254E';
export const RED_HOVER = '#C41A3D';
export const YELLOW = '#F9DC5C';
export const YELLOW_HOVER = '#D4B830';
export const DARK_TEXT = '#1a1a1a';

// Yellow is a FILL color, not a text color. YELLOW is 1.36:1 on white and
// YELLOW_HOVER is 1.96:1 - both fail WCAG AA (4.5:1) and even the 3:1 bar
// for large text, so neither may be used as text on a light surface.
// YELLOW_TEXT is the accessible stand-in: 6.00:1 on #FFFFFF and 5.54:1 on
// the #F4F6F8 neutral surface. It is deliberately NOT part of the brand
// pair pinned by brandColorParity.test.js - it is a derived a11y token.
// On DARK surfaces keep using YELLOW (12.58:1 on #161C24); this token is
// too dark there, so gate on palette.mode.
export const YELLOW_TEXT = '#7A6000';

// Mode-aware "Option B / That" TEXT color. Pass an MUI theme:
//   sx={{ color: yellowText }}   // theme callback, resolves per mode
// Dark surfaces keep the bright YELLOW; light surfaces get YELLOW_TEXT.
export const yellowText = (theme: { palette: { mode: string } }): string =>
  (theme.palette.mode === 'dark' ? YELLOW : YELLOW_TEXT);

// Frosted auth-card surface (Login/Register hero card). These are NEUTRAL
// surface tokens, not brand colors - they live here because component files
// may not contain color literals (only theme/palette.js, brandColors.ts,
// and utils/presence.js may). Deliberately excluded from the brand pair
// pinned by brandColorParity.test.js.
export const AUTH_CARD_BG_DARK = 'rgba(28, 30, 38, 0.92)';
export const AUTH_CARD_BG_LIGHT = 'rgba(255, 255, 255, 0.98)';

// Mode-aware auth-card background for MUI sx: sx={{ bgcolor: authCardBg }}
export const authCardBg = (theme: { palette: { mode: string } }): string =>
  (theme.palette.mode === 'dark' ? AUTH_CARD_BG_DARK : AUTH_CARD_BG_LIGHT);
